import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import for table support
import * as XLSX from 'xlsx'; // Import xlsx for Excel export

const TodoList = () => {
    const [todos, setTodos] = useState([]);
    const [filteredTodos, setFilteredTodos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch todos when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}todos?staff_id=1`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setTodos(data.data); // Store the todos data
                    setFilteredTodos(data.data); // Set initial filtered todos
                } else {
                    alert('Error fetching todos');
                }
            })
            .catch(error => console.error('Error fetching todos:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter todos based on the search term
        const filtered = todos.filter(todo =>
            todo.title.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredTodos(filtered);
    };

    // Navigate to the add todo page
    const handleAdd = () => {
        navigate('/AddTodo');
    };

    // Handle todo deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this todo?")) {
            fetch(`${BASE_URL}todos/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted todo from both lists (todos and filteredTodos)
                        setTodos(todos.filter(todo => todo.id !== id));
                        setFilteredTodos(filteredTodos.filter(todo => todo.id !== id));
                    } else {
                        alert('Error deleting todo');
                    }
                })
                .catch(error => {
                    console.error('Error deleting todo:', error);
                    alert('An error occurred while deleting the todo');
                });
        }
    };

    // Export filtered todos to PDF
    const handleExportPDF = () => {
        const doc = new jsPDF();

        // Add Title
        doc.text('Todo List', 14, 10); // Title at top of PDF

        // Prepare table data for PDF
        const tableData = filteredTodos.map(todo => [
            todo.id,
            todo.title || 'N/A',
            new Date(todo.created_at).toLocaleString(),
        ]);

        // Add table to PDF with autoTable
        doc.autoTable({
            head: [['ID', 'Title', 'Created At']], // Table headers
            body: tableData,
        });

        // Save the PDF with a filename
        doc.save('todo_list.pdf');
    };

    // Export filtered todos to Excel
    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredTodos.map(todo => ({
            ID: todo.id,
            Title: todo.title || 'N/A',
            CreatedAt: new Date(todo.created_at).toLocaleString(),
        })));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Todo List");

        // Save the Excel file with a filename
        XLSX.writeFile(workbook, 'todo_list.xlsx');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Todo List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Todo Table */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Todo</button>
                                        {/* Export to PDF Button */}
                                        <button className="btn btn-secondary ms-2" onClick={handleExportPDF}>Export to PDF</button>
                                        {/* Export to Excel Button */}
                                        <button className="btn btn-secondary ms-2" onClick={handleExportExcel}>Export to Excel</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Title</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search todo title"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Title</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredTodos.map(todo => (
                                                <tr key={todo.id}>
                                                    <td>{todo.id}</td>
                                                    <td>{todo.title || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(todo.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TodoList;
